module.exports = __webpack_public_path__ + "img/perform_1.4ad2cf2e.svg";